<template>
  <div class="page" v-loading="loading">
    <div class="content">
      <!-- 头部 -->
      <Step :active="2" :detail="detail" @refresh="getDetail" />
      <!-- 基本信息 -->
      <div class="base-info">
        <h2 class="title">基本信息：</h2>
        <div class="base-list">
          <div class="base-item">
            <div class="base-label">客户企业：</div>
            <div class="base-value">
              {{ detail.companyName }}
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">最终客户名称：</div>
            <div class="base-value">
              {{ detail.finalCompanyName || '-' }}
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">最终客户统一社会信用代码：</div>
            <div class="base-value">
              {{ detail.finalSocialCreditCode || '-' }}
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">客户合同号：</div>
            <div class="base-value">
              {{ detail.customerContractCode || '-' }}
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">项目名称：</div>
            <div class="base-value">
              {{ detail.projectName || '-' }}
            </div>
          </div>
        </div>
      </div>
      <!-- 收货地址 -->
      <div class="base-info">
        <h2 class="title">收货地址：</h2>
        <div class="base-list" v-if="detail.receiveAddress">
          <div class="base-item">
            <div class="base-label">收货联系人：</div>
            <div class="base-value">
              {{ detail.receiveAddress.receiveGoodsPerson }}
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">联系电话：</div>
            <div class="base-value">
              {{ detail.receiveAddress.receiveGoodsPhone }}
            </div>
          </div>
          <div class="base-item">
            <div class="base-label">收货地址：</div>
            <div class="base-value">
              {{ detail.receiveAddress.province }}
              {{ detail.receiveAddress.city }}
              {{ detail.receiveAddress.area }}
              {{ detail.receiveAddress.address }}
            </div>
          </div>
        </div>
      </div>
      <!-- 商品明细 -->
      <div class="items-wrap">
        <div class="title-wrap">
          <h2 class="title">商品明细：</h2>
        </div>
        <ItemList :tableData="detail.itemList" />
        <!-- 底部内容 -->
        <div class="plc-bottom">
          <div class="plc-pagination">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 底部信息 -->
      <div class="bottom">
        <div class="bottom-price">
          <div>
            商品应付含税总额（元）：<span class="red"
              >￥{{ detail.totalPay | formatePrice }}</span
            >
          </div>
          <div>
            标准金额小计(元)：<span
              >￥{{ detail.payMoney | formatePrice }}</span
            >
          </div>
          <div>
            折扣优惠(元)：
            <span
              >￥{{ Math.abs(detail.discountMoney || 0) | formatePrice }}</span
            >
          </div>
        </div>
        <div class="bottom-btns">
          <div class="total-price">
            <span>应付含税总额(元)： </span>
            <span class="red">￥{{ detail.totalPay | formatePrice }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Step from './order/detailStep'
import ItemList from './order/itemList'
import Address from './order/address'
import { Base64 } from 'js-base64'
import { formatePrice } from '@/utils/formatePrice'

export default {
  components: {
    Step,
    ItemList,
    Address
  },
  filters: {
    formatePrice (val) {
      if (val) {
        if (typeof val !== 'number') {
          val = val - 0
        }
        return formatePrice(val.toFixed(2))
      }
      if (val === null) {
        return '-'
      }
      return '0.00'
    }
  },
  mounted () {
    this.getDetail()
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      detail: {},
      loading: false
    }
  },
  methods: {
    getDetail () {
      const id = Base64.decode(this.$route.query.id)
      this.loading = true
      this.$http
        .post('/front/oms/plc/user/queryOrderDetail', { id })
        .then(({ data: res }) => {
          this.loading = false
          if (res.code === 0) {
            this.detail = res.data
          }
        })
    },
    // 前端分页
    setFrontPage (data) {
      this.total = data.length
      this.currentPage = 1
      this.frontData = [...data]
      this.getFrontPage()
    },
    getFrontPage () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = this.currentPage * this.pageSize
      this.detail.itemList = this.frontData.slice(start, end) // slice() 方法不会改变原始数组
    },
    // 分页 每页多少条改变
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getFrontPage()
    },
    // 分页 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getFrontPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  overflow: auto;
  padding-bottom: 28px;
}

.content {
  display: flex;
  flex-direction: column;
  width: 1200px;
  margin: 0 auto;
}

.title {
  display: flex;
  font-size: 16px;
  margin: 0;
  color: #000000;
}

.base-info {
  background: #fff;
  margin-top: 16px;
  padding: 16px 28px;
  border-radius: 12px;
  .base-list {
    display: flex;
    flex-wrap: wrap;
    .base-item {
      display: flex;
      align-items: center;
      width: 33.33%;
      margin-top: 8px;
      color: #848484;
    }
    .base-label {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #3d3d3d;
      &.required::before {
        display: inline-block;
        content: '*';
        margin-right: 2px;
        font-size: 14px;
        color: #e93037;
      }
    }
    .base-value {
      padding-right: 28px;
      flex: 1;
    }
  }
}

.items-wrap {
  background: #fff;
  margin-top: 16px;
  border-radius: 12px;
}

.title-wrap {
  padding: 16px 28px;
}

.bottom {
  background: #fff;
  margin-top: 16px;
  border-radius: 12px;
  .red {
    color: #e93037;
    font-weight: 900;
    font-size: 20px;
  }
  .bottom-price {
    text-align: right;
    padding: 16px 28px;
    font-size: 16px;
    color: #666666;
    > div {
      padding-bottom: 8px;
    }
  }
  .bottom-btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #efeff2;
    padding: 10px 28px;
    .total-price {
      display: flex;
      align-items: center;
      color: #000;
      font-size: 12px;
    }
    .btn {
      min-width: 95px;
      height: 36px;
      padding: 8px 12px;
      border-radius: 8px;
      background: #2a54d1;
      font-size: 18px;
      font-weight: bold;
      line-height: 20px;
      color: #ffffff;
      margin-left: 12px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &.save {
        background: rgba(42, 84, 209, 0.4);
      }
    }
  }
}
</style>
